import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, reactive } from "vue";
import { useStore } from "vuex";
import GroupList from "./group-list/GroupList.vue";
import MenuList from "./menu-list/MenuList.vue";
import { ListType, TListType } from "./types";
import { firebaseAuth } from "@/main";
import { IUser } from "@/app/user/types";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const state = reactive<{ listType: TListType }>({
  listType: ListType.Menus,
});

onMounted(() => {
  if (firebaseAuth.currentUser && !currentUser.value.uid) {
    setCurrentUser({
      name: firebaseAuth.currentUser.displayName as string,
      uid: firebaseAuth.currentUser.uid,
      email: firebaseAuth.currentUser.email as string,
    });
  }

  getUsersAsync();
  getGroupsAsync();
  getMenusAsync();
});

const groupsJoin = computed(() => store.getters["GroupStore/getGroupsJoin"]);
const menus = computed(() => store.getters["MenuStore/getMenus"]);
const currentUser = computed(() => store.getters["UserStore/getCurrentUser"]);

const setCurrentUser = (currentUser: IUser) =>
  store.commit("UserStore/setCurrentUser", currentUser);

const getUsersAsync = () => store.dispatch("UserStore/getUsersAsync");
const getGroupsAsync = () => store.dispatch("GroupStore/getGroupsAsync");
const getMenusAsync = () => store.dispatch("MenuStore/getMenusAsync");
const createGroupAsync = () => store.dispatch("GroupStore/createGroupAsync");
const participateInGroupAsync = () =>
  store.dispatch("GroupStore/participateInGroupAsync");

function getGroups() {
  getGroupsAsync();
  setListType(ListType.Groups);
}

function getMenus() {
  getMenusAsync();
  setListType(ListType.Menus);
}

function setListType(type: TListType) {
  state.listType = type;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("button", {
        type: "text",
        onClick: getMenus
      }, "메뉴"),
      _createElementVNode("button", {
        type: "text",
        onClick: getGroups
      }, "점심 파티!")
    ]),
    (_unref(state).listType === 'Groups')
      ? (_openBlock(), _createBlock(GroupList, {
          key: 0,
          groups: _unref(groupsJoin)
        }, null, 8, ["groups"]))
      : (_openBlock(), _createBlock(MenuList, {
          key: 1,
          menus: _unref(menus),
          onSetListType: _cache[0] || (_cache[0] = ($event: any) => (setListType($event)))
        }, null, 8, ["menus"]))
  ], 64))
}
}

})